<template>
  <div class="change-acceptance-status">
    <el-dialog
      title="修改验收状态"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="700px"
      :before-close="handleClose"
    >
      <el-form
        ref="formEl"
        :model="form"
        :rules="rules"
        size="small"
        label-width="120px"
      >
        <el-form-item label="修改验收状态：" prop="acceptanceStatus">
          <el-select v-model="form.acceptanceStatus" style="width:360px" placeholder="请选择验收状态">
            <el-option label="可验收" :value="1" />
            <el-option label="不可验收" :value="2" />
            <el-option label="验收中" :value="3" />
            <el-option label="已验收" :value="4" />
          </el-select>
        </el-form-item>
        <el-form-item label="修改原因：" prop="reason">
          <el-select v-model="form.reason" style="width:360px" placeholder="请选择修改原因">
            <el-option label="学员服务期已结束，经多次催促未参加考试" value="学员服务期已结束，经多次催促未参加考试" />
            <el-option label="学员服务期已结束，参加考试未合格" value="学员服务期已结束，参加考试未合格" />
          </el-select>
        </el-form-item>
        <el-form-item label="证明材料：" prop="remark">
          <Upfile v-if="dialogVisible" v-model="form.remark" accept=".JPG, .jpg, .png, .PNG, .jpeg, .JPEG, .pdf" />
          <p class="form-tips">可上传jpg、png、pdf格式图片，最大不超过2M</p>
        </el-form-item>
      </el-form>
      <el-row style="margin-bottom:10px">
        <p class="module-title">修改记录</p>
      </el-row>
      <el-table :data="recordList" border size="small">
        <el-table-column align="center" label="修改验收状态" min-width="80px">
          <template v-slot="{ row }">
            <span v-if="row.acceptanceStatus === 1">可验收</span>
            <span v-else-if="row.acceptanceStatus === 2">不可验收</span>
            <span v-else-if="row.acceptanceStatus === 3">验收中</span>
            <span v-else-if="row.acceptanceStatus === 4">已验收</span>
            <span v-else> -- </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="修改原因" prop="reason" min-width="140px" />
        <el-table-column align="center" label="证明材料" prop="" min-width="60px">
          <template v-slot="{ row }">
            <a :href="row.remark" target="_blank">查看</a>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作人" prop="insertByName" min-width="80px" />
        <el-table-column align="center" label="操作时间" prop="insertDate" min-width="110px" />
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="saveing" size="small" type="primary" @click="handleSubmit">保 存</el-button>
        <el-button size="small" @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  updateAcceptanceData,
  getOrderUpdateRecord
} from '@/api/orderAdmin/orderList'
import Upfile from '@/components/upload/file'
import { processing } from '@/utils/handle.js'

export default {
  name: 'ChangeAcceptanceStatus',

  components: { Upfile, },
  data () {
    return {
      dialogVisible: false,
      form: {
        acceptanceStatus: '',
        reason: '',
        remark: ''
      },
      rules: {
        acceptanceStatus: [
          { required: true, message: "请选择验收状态!", trigger: "change" },
        ],
        reason: [
          { required: true, message: "请选择修改原因!", trigger: "change" },
        ],
        remark: [
          { required: true, message: "请上传图片!", trigger: ['change', 'blur'] },
        ]
      },
      saveing: false,
      recordList: []
    }
  },
  methods: {
    init (orderId) {
      this.form.orderId = orderId
      this.handleGetOrderUpdateRecord(orderId)
      this.dialogVisible = true
    },
    // 获取修改记录
    handleGetOrderUpdateRecord (orderId) {
      getOrderUpdateRecord({ orderId }).then(({ code, data }) => {
        if (code === 0) {
          this.recordList = data
        }
      })
    },
    handleSubmit () {
      this.$confirm(`是否确认修改验收状态?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.$refs.formEl.validate(valid => {
          if (valid) {
            this.saveing = true
            const params = {
              ...this.form
            }
            updateAcceptanceData(processing(params)).then(({ code }) => {
              if (code === 0) {
                this.$message.success('修改验收状态成功!')
                this.$emit('refresh')
                this.handleClose()
              }
            }).finally(() => {
              this.saveing = false
            })
          }
        })
      })
    },
    handleClose () {
      this.form = this.$options.data().form
      this.$refs.formEl && this.$refs.formEl.resetFields()
      this.dialogVisible = false
    }
  }
}
</script>

<style>

</style>
